import { validator } from "LIB/validate-this";
import {
  CARRIER,
  CITY,
  COMPANY,
  COUNTRY,
  LINE1,
  POSTAL_CODE,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_TYPE,
  SHIPPING_ADDRESS,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import * as rules from "LIB/validation/rules";
import { DROPSHIP } from "MODULES/PurchaseOrders/constants";

export default function(values) {
  return validator(values, form => {
    form.validate(SHIP_TO_TYPE).satisfies(rules.required);

    if (values.ship_to_type === COMPANY) {
      form
        .validate(SHIP_TO_COMPANY_ADDRESS_ID, SHIP_TO_COMPANY_ID)
        .satisfies(rules.required);
    }

    if (values.ship_to_type === DROPSHIP) {
      form.validateChild(SHIPPING_ADDRESS, s => {
        s.validate(COUNTRY, LINE1, CITY, POSTAL_CODE).satisfies(rules.required);
      });
    }

    form.validateChild(SHIPPING_METHOD, s => {
      s.validate(CARRIER, SHIPPING_METHOD).satisfies(rules.required);
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/ReturnToCustomer/validate.js